import { ReactComponent as HomeIcon } from '../assets/icons/menu/home.svg';
import { ReactComponent as CardsIcon } from '../assets/icons/menu/card.svg';
import { ReactComponent as GameIcon } from '../assets/icons/menu/game.svg';
// import { ReactComponent as ReferralIcon } from '../assets/icons/menu/referral.svg';
import { ReactComponent as WalletIcon } from '../assets/icons/menu/wallet.svg';
import { ReactComponent as PvpIcon } from '../assets/icons/menu/pvp.svg';

export const comingSoonActive = false;  

export const countDownFinishDate = new Date(Date.UTC(2025, 2, 1, 3, 0, 0));
export const bottomNavItems = [
  { name: "Home", path: "/", icon: HomeIcon },
  { name: "Cards", path: "/cards", icon: CardsIcon },
  { name: "Game", path: "/game", icon: GameIcon },
  { name: "PVP", path: "/pvp", icon: PvpIcon },
  // { name: "Referral", path: "/referral", icon: ReferralIcon },
  { name: "Wallet", path: "/wallet", icon: WalletIcon },

];

export const tokenList = [
  {
    id: 1,
    logo: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
    name: "Bitcoin",
    price: 50000,
    balance: 0.5,
    balanceUSD: 25000,
  },
  {
    id: 2,
    logo: "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
    name: "Ethereum",
    price: 3000,
    balance: 2,
    balanceUSD: 6000,
  },
];

export const cards = [
    { name: "Onionmantis", rarity: { name: "Normal" }, level: { value: 1 } ,type:"dark", weakness:"dragon",miningPower:10 },
    // { name: "Atummus", rarity: { name: "Rare" }, level: { value: 4 } ,type:"dark", weakness:"dragon",miningPower:10},
    { name: "Bunnypop", rarity: { name: "Mytical" }, level: { value: 5 } ,type:"dark", weakness:"dragon",miningPower:10},
    { name: "Crogle", rarity: { name: "Unique" }, level: { value: 2 },type:"dark", weakness:"dragon",miningPower:10 },
    { name: "Firelopex", rarity: { name: "Legend" }, level: { value: 5 },type:"dark", weakness:"dragon",miningPower:10 },
    { name: "Thundercat", rarity: { name: "Rare" }, level: { value: 3 } ,type:"dark", weakness:"dragon",miningPower:10},
  ]
  
export const rarityRank = {
  "Mythic": 5,
  "Legend": 4,
  "Unique": 3,
  "Rare": 2,
  "Normal": 1
};

export const BattleEvents = {
    JOIN:   'battle:join',
    QUEUED: 'battle:queued',
    READY:  'battle:ready',
    CARDS_SELECTED: 'battle:cardsSelected',
    OPPONENT_CARDS_SELECTED: 'battle:opponentCardsSelected',
    START:  'battle:start',
    UPDATE: 'battle:update',
    END:    'battle:end',
    ERROR:  'battle:error',
  };

export const SLOT_RANGE_PRICES = {
    RANGE_4_10: {
      price: 4.43,
      productId:11,
      productName:"Slot 4-10",
      productImage: "https://cryptid-hunter-mini.s3.eu-central-1.amazonaws.com/market/slot_4_10.png"
    },
    RANGE_11_15: {
      price: 23.01,
      productId:12,
      productName:"Slot 11-15",
      productImage: "https://cryptid-hunter-mini.s3.eu-central-1.amazonaws.com/market/slot_11_15.png"
    },
    RANGE_16_20: {
      price: 64.91,
      productId:13,
      productName:"Slot 16-20",
      productImage: "https://cryptid-hunter-mini.s3.eu-central-1.amazonaws.com/market/slot_16_20.png"
    },
    RANGE_21_24: {
      price: 115.42,
      productId:14,
      productName:"Slot 21-24",
      productImage: "https://cryptid-hunter-mini.s3.eu-central-1.amazonaws.com/market/slot_21_24.png"
    },
  };